import { InputOTP, InputOTPGroup, InputOTPSlot } from './ui/input-otp';
import { OTP_LENGTH } from '../utils/twoFactor';

interface OtpCodeInputProps {
  /** Aktueller Code (nur Ziffern). */
  value: string;
  /** Wird bei jeder Änderung mit dem bereinigten Code aufgerufen. */
  onChange: (value: string) => void;
  /** Wird aufgerufen, sobald alle {@link OTP_LENGTH} Stellen eingegeben sind (z.B. Auto-Submit). */
  onComplete?: (value: string) => void;
  /** Sperrt die Eingabe, z.B. während eine Anfrage läuft. */
  disabled?: boolean;
  /** Fokussiert das Feld beim Einblenden. */
  autoFocus?: boolean;
  /** Markiert das Feld als fehlerhaft (a11y + Styling). */
  invalid?: boolean;
  /** Eindeutige ID, damit ein `<Label htmlFor>` darauf zeigen kann. */
  id?: string;
}

/**
 * Eingabe eines 6-stelligen Einmalcodes (TOTP) mit einzelnen Ziffernfeldern.
 * Akzeptiert nur Ziffern und unterstützt Einfügen aus der Zwischenablage sowie
 * das Autofill-Attribut `one-time-code`.
 */
export function OtpCodeInput({ value, onChange, onComplete, disabled, autoFocus, invalid, id }: OtpCodeInputProps) {
  return (
    <InputOTP
      id={id}
      maxLength={OTP_LENGTH}
      value={value}
      onChange={onChange}
      onComplete={onComplete}
      disabled={disabled}
      autoFocus={autoFocus}
      inputMode="numeric"
      pattern="^[0-9]*$"
      autoComplete="one-time-code"
      aria-invalid={invalid || undefined}
      containerClassName="justify-center"
    >
      <InputOTPGroup>
        {Array.from({ length: OTP_LENGTH }, (_, index) => (
          <InputOTPSlot key={index} index={index} aria-invalid={invalid || undefined} className="h-11 w-11 text-lg" />
        ))}
      </InputOTPGroup>
    </InputOTP>
  );
}
